/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2025-04-24 16:49:39
 */
import React, { useCallback, useState } from 'react'
import { Button, Modal, Input } from 'antd'
import { produce } from 'immer'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import {
  updateOrNewWatermark,
  fetchGroupWatermarks
} from '../../../../actions/watermark'
import { subWatermarkText } from '../../../../utils/utils'
import * as WM from '../../typings'

const RenameButton: React.FC<WM.RenameButtonProps> = ({ watermark }) => {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.main.user)
  const groupID = useAppSelector((state) => state.group.groupId)
  const [name, setName] = useState<string | undefined>('')
  const [renameModalVisible, setRenameModalVisible] = useState<boolean>(false)

  const fetchWatermarks = useCallback(() => {
    dispatch(
      fetchGroupWatermarks({
        userID: user?.user_id,
        groupID: groupID
      })
    )
  }, [user, groupID])

  const onRenameClick = useCallback(() => {
    setName(watermark.watermarkContent?.name || '')
    setRenameModalVisible(true)
  }, [watermark])

  const onRename = useCallback(() => {
    if (watermark && name && watermark.watermarkContent) {
      const content = produce(watermark.watermarkContent, (draft) => {
        if (!draft) return
        draft.name = name
        draft.update_time = String(new Date().getTime())
      })
      if (!content) return
      const usedItems = content.items
        .filter((item) => item.switchStatus)
        .map((item) => item.id)
      if (content.logo?.switchStatus) {
        usedItems.push(content.logo.id)
      }
      if (content.theme?.switchStatus) {
        usedItems.push(content.theme.id)
      }
      dispatch(
        updateOrNewWatermark({
          userID: user?.user_id,
          groupID: groupID,
          watermark: {
            id: watermark.id,
            baseID: watermark.baseID,
            content: JSON.stringify(content),
            updateTime: content.update_time
          },
          insInfo: {
            operateTemplateID: '',
            fromPlace: 'webWatermarkManage',
            isAutoCreateGroup: 0
          },
          usedItems: usedItems
        })
      )
        .then(fetchWatermarks)
        .then(() => {
          setRenameModalVisible(false)
          setName('')
        })
    }
  }, [watermark, name])

  return (
    <span>
      <Button
        key="rename"
        type="link"
        disabled={!watermark.watermarkContent}
        onClick={() => onRenameClick()}
      >
        重命名
      </Button>
      <Modal
        getContainer={false}
        title="模板重命名"
        open={renameModalVisible}
        onCancel={() => {
          setRenameModalVisible(false)
          setName('')
        }}
        onOk={onRename}
        okButtonProps={{ disabled: !name || !name.trim() }}
      >
        <Input
          value={name}
          onChange={(e) => setName(subWatermarkText(e.target.value, 12))}
        />
        <p style={{ marginTop: '10px' }}>名称最多可输入12个汉字</p>
      </Modal>
    </span>
  )
}

export default RenameButton
